import { createFileRoute } from '@tanstack/react-router';

import { UtmScreen } from '@/screens/settings/UtmScreen';

export const Route = createFileRoute('/_app/settings/utm')({
  component: UtmScreen,
});
